import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import VehicleBarChart from './VehicleBarChart';
import GenderPieChart from './GenderPieChart';
import BirthdayList from '../CRM/BirthdayList';
import WelcomeBanner from './WelcomeBanner';
import { useAuth } from '../Auth/Auth';
import {
  UsersIcon,
  WrenchScrewdriverIcon,
  ClipboardDocumentListIcon,
  TruckIcon,
  MagnifyingGlassIcon,
  ArrowTrendingUpIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';


const Home = () => {
  
  const [customerCount, setCustomerCount] = useState("NIL");
  // const [jobCount, setJobCount] = useState("NIL");
  const [vehicleCount, setVehicleCount] = useState("NIL");
  const [openJobCount, setOpenJobCount] = useState("NIL");
  const [approvedJobCount, setApprovedJobCount] = useState("NIL");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchType, setSearchType] = useState("select");
  const [searchResults, setSearchResults] = useState(null);
  const [genderCount, setGenderCount] = useState({});
  const { user } = useAuth();
 

   // Count Customers
   useEffect(() => {
    const fetchCustomerCount = async () => {
      const customerCol = collection(db, 'customers');
      const customerSnapshot = await getDocs(customerCol);

      if (customerSnapshot.size > 0) {
        setCustomerCount(customerSnapshot.size);
      }
    };

    fetchCustomerCount();
  }, []);

  //  // Count Jobs
  //  useEffect(() => {
  //   const fetchJobCount = async () => {
  //     const JobCol = collection(db, 'jobs');
  //     const jobSnapshot = await getDocs(JobCol);

  //     if (jobSnapshot.size > 0) {
  //       setJobCount(jobSnapshot.size);
  //     }
  //   };

  //   fetchJobCount();
  // }, []);

  // Approved Jobs
  useEffect(() => {
    const fetchApprovedJobCount = async () => {
      const JobCol = collection(db, 'jobs');
      const openJobQuery = query(JobCol, where('approvalStatus', '==', 'Yes'));
      const jobSnapshot = await getDocs(openJobQuery);

      if (jobSnapshot.size > 0) {
        setApprovedJobCount(jobSnapshot.size);
      }
    };

    fetchApprovedJobCount();
  }, []);




    // Open Jobs
    useEffect(() => {
      const fetchOepnJobCount = async () => {
        const JobCol = collection(db, 'jobs');
        const openJobQuery = query(JobCol, where('status', '==', 'Open'));
        const jobSnapshot = await getDocs(openJobQuery);
  
        if (jobSnapshot.size > 0) {
          setOpenJobCount(jobSnapshot.size);
        }
      };
  
      fetchOepnJobCount();
    }, []);

   // Registered Vehicles
   useEffect(() => {
    const fetchVehicleCount = async () => {
      const VehicleCol = collection(db, 'vehicles');
      const vehicleSnapshot = await getDocs(VehicleCol);

      if (vehicleSnapshot.size > 0) {
        setVehicleCount(vehicleSnapshot.size);
      }
    };

    fetchVehicleCount();
  }, []);

  useEffect(() => {
    const fetchGenderCount = async () => {
      const customerCol = collection(db, 'customers');
      const customerSnapshot = await getDocs(customerCol);

      if (customerSnapshot.size > 0) {
        let maleCount = 0, femaleCount = 0;
        customerSnapshot.docs.forEach(doc => {
          const customer = doc.data();
          if (customer.gender === "Male") maleCount++;
          else if (customer.gender === "Female") femaleCount++;
        });

        setGenderCount({ Male: maleCount, Female: femaleCount });
      }
    };

    fetchGenderCount();
  }, []);

 
  const handleChange = event => {
    setSearchTerm(event.target.value);
  };
  
  const handleSelect = event => {
    setSearchType(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSearchResults(null);
    const upperCaseSearchTerm = searchTerm.toUpperCase();
  
    if (searchType === "jobCardNo") {
      const q = query(collection(db, "jobs"), where("jobCardNo", "==", upperCaseSearchTerm));
      const querySnapshot = await getDocs(q);
  
      if (querySnapshot.empty) {
        setSearchResults('No matching documents.');
      } else {
        setSearchResults(querySnapshot.docs.map(doc => doc.data()));
      }
  
    } else if(searchType === "invoiceNumber") {
      const q = query(collection(db, "invoices"), where("invoiceNumber", "==", upperCaseSearchTerm));
      const querySnapshot = await getDocs(q);
  
      if (querySnapshot.empty) {
        setSearchResults('No matching documents.');
      } else {
        setSearchResults(querySnapshot.docs.map(doc => ({
          approvalStatus: doc.data().approvalStatus,
          date: doc.data().date,
          invoiceStatus: doc.data().invoiceStatus,
          id: doc.id
        })));
      }
    } else if(searchType === "registrationNumber") {
      const q = query(collection(db, "vehicles"), where("registrationNumber", "==", upperCaseSearchTerm));
      const querySnapshot = await getDocs(q);
  
      if (querySnapshot.empty) {
        setSearchResults('No matching documents.');
      } else {
        setSearchResults(querySnapshot.docs.map(doc => ({
          vehicleMake: doc.data().vehicleMake,
          vehicleModel: doc.data().vehicleModel,
          id: doc.id
        })));
      }
    } else if(searchType === "GIN") {
      const q = query(collection(db, "vehicles"), where("GIN", "==", upperCaseSearchTerm));
      const querySnapshot = await getDocs(q);
  
      if (querySnapshot.empty) {
        setSearchResults('No matching documents.');
      } else {
        setSearchResults(querySnapshot.docs.map(doc => ({
          vehicleMake: doc.data().vehicleMake,
          vehicleModel: doc.data().vehicleModel,
          id: doc.id
        })));
      }
    }


  };
  

  return (
    <>
      <WelcomeBanner user={user} />

      {/* Stats Cards */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 mb-8">
        {/* Customers Card */}
        <Link to="/customers" className="group">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-emerald-100 text-sm font-medium mb-1">Customers</p>
                <p className="text-white text-4xl font-bold">{customerCount}</p>
              </div>
              <div className="rounded-full bg-white/20 p-4 backdrop-blur-sm">
                <UsersIcon className="h-8 w-8 text-white" />
              </div>
            </div>
            <div className="absolute bottom-0 right-0 opacity-10">
              <UsersIcon className="h-32 w-32 text-white" />
            </div>
          </div>
        </Link>

        {/* Open Jobs Card */}
        <Link to="/vehicles/openjobs" className="group">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-amber-100 text-sm font-medium mb-1">Open Jobs</p>
                <p className="text-white text-4xl font-bold">{openJobCount}</p>
              </div>
              <div className="rounded-full bg-white/20 p-4 backdrop-blur-sm">
                <WrenchScrewdriverIcon className="h-8 w-8 text-white" />
              </div>
            </div>
            <div className="absolute bottom-0 right-0 opacity-10">
              <WrenchScrewdriverIcon className="h-32 w-32 text-white" />
            </div>
          </div>
        </Link>

        {/* Total Jobs Card */}
        <Link to="/vehicles/alljobs" className="group">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-indigo-600 to-purple-700 p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-indigo-100 text-sm font-medium mb-1">Total Jobs</p>
                <p className="text-white text-4xl font-bold">{approvedJobCount}</p>
              </div>
              <div className="rounded-full bg-white/20 p-4 backdrop-blur-sm">
                <ClipboardDocumentListIcon className="h-8 w-8 text-white" />
              </div>
            </div>
            <div className="absolute bottom-0 right-0 opacity-10">
              <ClipboardDocumentListIcon className="h-32 w-32 text-white" />
            </div>
          </div>
        </Link>

        {/* Registered Vehicles Card */}
        <div className="group">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-rose-500 to-pink-600 p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-rose-100 text-sm font-medium mb-1">Registered Vehicles</p>
                <p className="text-white text-4xl font-bold">{vehicleCount}</p>
              </div>
              <div className="rounded-full bg-white/20 p-4 backdrop-blur-sm">
                <TruckIcon className="h-8 w-8 text-white" />
              </div>
            </div>
            <div className="absolute bottom-0 right-0 opacity-10">
              <TruckIcon className="h-32 w-32 text-white" />
            </div>
          </div>
        </div>
      </div>


      {/* Main Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        {/* Search Section */}
        <div className="lg:col-span-2">
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl border border-indigo-100 overflow-hidden">
            <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-4">
              <h3 className="text-lg font-bold text-white flex items-center gap-2">
                <MagnifyingGlassIcon className="h-6 w-6" />
                Quick Search
              </h3>
            </div>
            <div className="p-6">
              <form className="space-y-4" onSubmit={handleSubmit}>
                <div className="flex flex-col md:flex-row gap-3">
                  <div className="flex-1 relative">
                    <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                    <input
                      type="text"
                      placeholder="Search..."
                      className="w-full pl-10 pr-4 py-3 rounded-xl border-2 border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
                      value={searchTerm}
                      onChange={handleChange}
                    />
                  </div>
                  <select
                    className="px-4 py-3 rounded-xl border-2 border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-gray-700 font-medium transition-all duration-200"
                    value={searchType}
                    onChange={handleSelect}
                  >
                    <option value="select">Select Type</option>
                    <option value="jobCardNo">Job Card No</option>
                    <option value="registrationNumber">Vehicle Reg. Number</option>
                    <option value="GIN">GIN</option>
                    <option value="invoiceNumber">Invoice Number</option>
                  </select>
                  <button
                    type="submit"
                    className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-xl hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transform hover:scale-105 transition-all duration-200 shadow-lg"
                  >
                    Search
                  </button>
                </div>
                <p className="text-center text-xs text-gray-500 font-medium">
                  Search by Job Card, Invoice, GIN, or Plate Number
                </p>
              </form>

              {/* Search Results */}
              <div className="mt-6">
                {searchResults === 'No matching documents.' ? (
                  <div className="text-center py-8">
                    <div className="mx-auto h-12 w-12 text-red-400">
                      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                      </svg>
                    </div>
                    <p className="mt-2 text-sm font-medium text-red-600">{searchResults}</p>
                  </div>
                ) : searchResults ? (
                  <div className="space-y-4">
                    {searchResults.map((result, index) => (
                      <div
                        key={index}
                        className="p-4 rounded-xl bg-gradient-to-br from-indigo-50 to-purple-50 border border-indigo-100 hover:shadow-md transition-all duration-200"
                      >
                        {searchType === 'invoiceNumber' ? (
                          <>
                            <p className="text-sm font-semibold text-gray-700">
                              Approval Status: <span className="text-indigo-600">{result.approvalStatus}</span>
                            </p>
                            <p className="text-sm text-gray-600">
                              Date: {new Date(result.date.seconds * 1000).toLocaleDateString()}
                            </p>
                            <p className="text-sm text-gray-600">Status: {result.invoiceStatus}</p>
                            <Link
                              to={`/finance/invoices/${result.id}`}
                              className="inline-block mt-2 text-sm font-semibold text-indigo-600 hover:text-indigo-800 hover:underline"
                            >
                              View More →
                            </Link>
                          </>
                        ) : searchType === 'registrationNumber' || searchType === 'GIN' ? (
                          <>
                            <p className="text-sm font-semibold text-gray-700">
                              Vehicle: <span className="text-indigo-600">{result.vehicleMake} {result.vehicleModel}</span>
                            </p>
                            <Link
                              to={`/vehicles/vehicleHistory/${result.id}`}
                              className="inline-block mt-2 text-sm font-semibold text-indigo-600 hover:text-indigo-800 hover:underline"
                            >
                              View Service History →
                            </Link>
                          </>
                        ) : (
                          <>
                            <p className="text-sm font-semibold text-gray-700">
                              Registration: <span className="text-indigo-600">{result.registrationNumber}</span>
                            </p>
                            <p className="text-sm text-gray-600">
                              Vehicle: {result.vehicleMake} {result.vehicleModel}
                            </p>
                            <p className="text-sm text-gray-600">
                              Created: {new Date(result.createdAt?.seconds * 1000).toLocaleDateString()}
                            </p>
                            <p className="text-sm text-gray-600">Status: {result?.status}</p>
                            <Link
                              to={`/vehicles/jobdetail/${result.jobCardNo}`}
                              className="inline-block mt-2 text-sm font-semibold text-indigo-600 hover:text-indigo-800 hover:underline"
                            >
                              View More →
                            </Link>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        {/* Birthday List */}
        <div className="lg:col-span-1">
          <BirthdayList />
        </div>
      </div>

      {/* Analytics Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Customer Statistics */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl border border-indigo-100 overflow-hidden">
          <div className="bg-gradient-to-r from-emerald-500 to-teal-600 px-6 py-4">
            <h4 className="text-lg font-bold text-white flex items-center gap-2">
              <ChartBarIcon className="h-6 w-6" />
              Customer Statistics
            </h4>
          </div>
          <div className="p-6">
            <GenderPieChart data={genderCount} />
          </div>
        </div>

        {/* Vehicle Demographics */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl border border-indigo-100 overflow-hidden">
          <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-4">
            <h4 className="text-lg font-bold text-white flex items-center gap-2">
              <ArrowTrendingUpIcon className="h-6 w-6" />
              Vehicle Demographics
            </h4>
          </div>
          <div className="p-6">
            <VehicleBarChart />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
